import React from 'react'
import { Avatar, Box, Paper, Stack, Typography, List, ListItemButton, ListItemText, Divider, Card, CardContent, CardActions, Button } from "@mui/material";
import { styled } from '@mui/material/styles';

const Carousel = (props:any) => {
    return <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        sx={{ overflow: 'hidden', overflowX: "scroll", padding: "5px" }}
    >
        {props.childrens.map((children:any, key:number) => (Component(children.type, { ...children.props, key })))}
    </Stack>
}

const ListGroup = (props:any) => {
    const handleListItemClick = (event:any, item:any) => {
        console.log(event, item)
        if (item.onClick) {
            let text = item.onClick.text
            let postback = item.onClick.postback
        }
    }
    return <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} key={props.key}>
        <List component="nav">
            {props.data.map((item:any, index:any) => <React.Fragment key={index}><ListItemButton

                onClick={(event) => handleListItemClick(event, item)}
            >
                <ListItemText primary={item.title} />
            </ListItemButton>{(index < props.data.length - 1) && <Divider />}</React.Fragment>)}
        </List>
    </Box>
}

const MyCard = (props:any) => {
    return <Card sx={{ width: "310px", marginRight: "10px" }} key={props.key}>
        <CardContent>
            {props.data.title != "" && <Typography gutterBottom variant="h5" component="div">{props.data.title}</Typography>}
            {props.data.short_desc != "" && <Typography variant="body2" color="text.secondary">{props.data.short_desc}</Typography>}
        </CardContent>
        {props.data.title != "" && <CardActions sx={{ justifyContent: "center" }}>
            <Button variant="contained" sx={{ flex: 1 }}>{props.data.button}</Button>
        </CardActions>}
    </Card>
}

const Components:any = {
    Carousel,
    ListGroup,
    Card: MyCard
}

const Component = (type:any, props:any) => {
    return Components[type](props)
}

const RichMessage:any = ({data}:any)=>{
    return Component(data.type, data.props)
}

export { RichMessage }